import { useMutation } from '@tanstack/react-query';

import {
  BulkDeleteVoucherUsersPayload,
  BulkDeleteVoucherUsersResponse,
  bulkDeleteVoucherUsers,
} from '~/services/PromoService';

export function useBulkDeleteVoucherUsers() {
  return useMutation<BulkDeleteVoucherUsersResponse, Error, BulkDeleteVoucherUsersPayload>({
    mutationFn: async (payload) => bulkDeleteVoucherUsers(payload),
  });
}
